import { PickupLocation } from "@redotech/redo-model/return";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const reschedulePickup = {
  name: "reschedulePickup" as const,
  input: z.object({
    returnId: zExt.objectId(),
    pickupDate: z.string().optional(), // ISO date string from Temporal.PlainDate
    location: createEnum(PickupLocation).optional(),
  }),
  output: z.object({}),
};
